// extracted by mini-css-extract-plugin
export default {"root":"BadgeWrapper_root__uG+6A","loader":"BadgeWrapper_loader__J1K-q","rotating":"BadgeWrapper_rotating__ZdZtJ","notification":"BadgeWrapper_notification__uQj1+"};